*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: contents;
}

/* ===== Dialog 容器 ===== */
dialog {
  /* 默认：右侧滑出 — 需显式 left:auto 覆盖 UA dialog:modal 的 left:0 */
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  transform: translateX(100%);

  /* 阴影属于抽屉主体，不能由同尺寸的原生 dialog 裁剪。内容滚动由 .wui-drawer-content 管理。 */
  overflow: visible;

  box-sizing: border-box;
  width: var(--wui-drawer-width, 320px);
  max-width: 90vw;
  height: 100vh;
  height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  margin: 0;
  padding: 0;
  border: none;

  font-family: inherit;
  color: var(--wui-color-text, #1b1b1b);

  background: transparent;

  transition: transform var(--wui-duration-drawer-enter, 280ms) var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1));

  &::backdrop {
    opacity: 0;
    background: var(--wui-drawer-overlay-bg, var(--wui-color-backdrop, rgb(0 0 0 / 0.12)));
    transition: opacity var(--wui-duration-drawer-enter, 280ms) var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1));
  }
}

dialog[open].is-visible {
  transform: translate(0, 0);
}

:host([placement='left']) dialog[open].is-visible,
:host([placement='top']) dialog[open].is-visible,
:host([placement='bottom']) dialog[open].is-visible {
  transform: translate(0, 0);
}

dialog.is-closing {
  pointer-events: none;
  transition: transform var(--wui-duration-drawer-exit, 240ms) var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1));
}

dialog.is-closing::backdrop {
  transition: opacity var(--wui-duration-drawer-exit, 240ms) var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1));
}

dialog[open].is-visible::backdrop {
  opacity: 1;
}

/* ===== Placement 变体 ===== */

:host([placement='left']) dialog {
  right: auto;
  left: 0;
  transform: translateX(-100%);
}

:host([placement='top']) dialog,
:host([placement='bottom']) dialog {
  width: 100vw;
  max-width: 100vw;
  height: var(--wui-drawer-height, 300px);
  max-height: 90dvh;
}

:host([placement='top']) dialog {
  top: 0;
  right: 0;
  bottom: auto;
  left: 0;
  transform: translateY(-100%);
}

:host([placement='bottom']) dialog {
  top: auto;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateY(100%);
}

/* ===== 抽屉主体 ===== */

.wui-drawer-body {
  --wui-internal-glass-shadow: var(--wui-shadow-overlay, 2px 16px 40px rgb(0 0 0 / 0.4));
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: var(--wui-drawer-bg, var(--wui-color-surface-overlay, rgb(246 246 246 / 0.82)));
}

/* ===== Header ===== */

.wui-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 16px 20px;
  border-bottom: 1px solid rgb(0 0 0 / 0.06);

  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
}

/* ===== 隐藏态 ===== */

.wui-drawer-header[hidden] {
  display: none;
}

/* ===== 内容区 ===== */

.wui-drawer-content {
  overflow-y: auto;
  overscroll-behavior: contain;
  flex: 1;

  padding: 20px;

  font-size: var(--wui-font-size, 14px);
  line-height: 1.5;
  color: var(--wui-color-text, #1b1b1b);
}

/* ===== Footer ===== */

.wui-drawer-footer {
  flex-shrink: 0;
  padding: 16px 20px;
  border-top: 1px solid rgb(0 0 0 / 0.06);
}

@media (prefers-reduced-motion: reduce) {
  dialog {
    transition: opacity var(--wui-duration-feedback, 100ms) ease;
  }

  dialog::backdrop {
    transition-duration: var(--wui-duration-feedback, 100ms);
  }

  dialog[open].is-visible {
    transform: none;
  }
}

.wui-drawer-footer[hidden] {
  display: none;
}

/* ===== 关闭按钮（独立定位，与 header 解耦） ===== */

.wui-drawer-close {
  position: absolute;
  z-index: 3;
  top: 16px;
  right: 16px;
}

/* ===== Headless 模式 ===== */

/* Headless 模式下，dialog 只作为 overlay 容器，不渲染内置 UI */
:host([headless]) dialog {
  /* 保持 overlay 基础设施，移除内置样式 */
  width: auto;
  max-width: none;
}
